/* eslint-disable react-hooks/exhaustive-deps */
import { useSearchParameter } from "hooks";
import { useEffect } from "react";

import { ChartRangeType } from "../constants";

const useValidActiveChartRangeType = (): {
  activeRangeType: ChartRangeType;
  setActiveRangeType: (value: ChartRangeType) => void;
} => {
  const [chartRangeTypeSearchParameter, setChartRangeTypeSearchParameter] =
    useSearchParameter("chartRangeType");

  const VALID_RANGE_TYPES: ChartRangeType[] = [
    ChartRangeType.Week,
    ChartRangeType.Month,
    ChartRangeType.Year,
    ChartRangeType.Custom
  ];

  useEffect(() => {
    if (!chartRangeTypeSearchParameter) {
      setChartRangeTypeSearchParameter(ChartRangeType.Week);
    }
  }, [chartRangeTypeSearchParameter]);

  const activeRangeType =
    VALID_RANGE_TYPES.find(
      (option) => option === chartRangeTypeSearchParameter
    ) ?? ChartRangeType.Week;

  return {
    activeRangeType,
    setActiveRangeType: setChartRangeTypeSearchParameter
  };
};

export default useValidActiveChartRangeType;
